import React from "react";

const PlaceholderImage = () => (
  <div className="d-flex justify-content-center align-items-center w-100 h-100 bg-lightblue">
    <i className="bx bx-image-alt font-size-20 text-primary" />
  </div>
);

export default PlaceholderImage;
